<script lang="ts">import { t } from "@infinitro/content";
import { isMobile, isTablet, loggedIn, toSiteUrl } from "@infinitro/global";
import { Text } from "@infinitro/text";
export let backgroundImage;
export let backgroundImageMobile;
export let title;
export let description;
export let linkUrl;
export let badgeText;
export let badgeGradient;
export let position = "left";
function formatTitle(text) {
	return text.split(" ").join("<br>");
}
function formatDescription(text) {
	if (text.includes(" + ")) {
		return text.replace(/\s*\+\s*/g, "<br>");
	}
	const words = text.split(" ");
	const middleIndex = Math.floor(words.length / 2);
	const firstHalf = words.slice(0, middleIndex).join(" ");
	const secondHalf = words.slice(middleIndex).join(" ");
	return `${firstHalf}<br>${secondHalf}`;
}
$: href = linkUrl ? toSiteUrl(linkUrl, $loggedIn) : undefined;
$: isPhone = $isMobile && !$isTablet;
</script>

<a class="small-card" {href} data-sveltekit-preload-data="off">
	<img
		src={$isMobile ? backgroundImageMobile : backgroundImage}
		alt={title}
		class="small-card-bg small-card-bg-{position}"
	/>
	<div class="small-card-content small-card-content-{position}">
		<div class="content-wrapper">
			{#key `${$isMobile}-${$isTablet}`}
				<Text
					type="subtitle"
					subtitleSize={isPhone ? 'medium' : 'large'}
					subtitleWeight="extrabold"
					customStyle="font-weight: 900; line-height: {isPhone
						? '16px'
						: '24px'}; font-size: {isPhone
						? '16px'
						: '22px'}; text-shadow: 0 0 4px rgba(0, 0, 0, 0.7);"
					textAlign={position === 'left' ? 'start' : 'end'}
				>
					{@html formatTitle($t(title))}
				</Text>

				<div>
					<Text
						bodyWeight={isPhone ? 'semibold' : 'regular'}
						bodySize={'small'}
						textAlign={position === 'left' ? 'start' : 'end'}
						customStyle="font-size: {isPhone ? '12px' : '12px'}; line-height: {isPhone
							? '120%'
							: '130%'}; text-shadow: 0 0 4px rgba(0, 0, 0, 0.7);"
					>
						{@html formatDescription($t(description))}
					</Text>
					<!-- {#if badgeText && !$isMobile}
						<div class="cta cta-{position}">
							<span
								class="badge"
								style="
    background:
      linear-gradient(
        {position === 'left' ? '90deg' : '270deg'},
        transparent 0%,
        color-mix(in srgb, var(--color-primary-500) 9%, transparent) 100%
      ),
      {badgeGradient};
  "
							>
								<span class="badge-text">
									{$t(badgeText)}
								</span>
							</span>
						</div>
					{/if} -->
				</div>
			{/key}
		</div>
	</div>
</a>

<style>
	.small-card {
		position: relative;
		display: block;
		cursor: pointer;
		overflow: hidden;
		border-radius: 12px;
		color: inherit;
		text-decoration-line: none;
		width: calc(50% - 0.25rem);
		aspect-ratio: 353/200;
}

	.small-card::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		border-radius: 12px;
		padding: 1px;
		background: linear-gradient(
			180deg,
			rgba(var(--color-primary-500-rgb) / 0.9) 0%,
			rgba(255, 255, 255, 0) 100%
		);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
		z-index: 1;
	}

	.small-card-bg {
		position: absolute;
		top: 0px;
		display: block;
		height: 100%;
		width: auto;
		max-width: none;
}

	.small-card-content {
		position: absolute;
		z-index: 20;
		display: flex;
		padding: 0.875rem;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
}

	.small-card-content-left {
		align-items: center;
		justify-content: flex-start;
}

	.small-card-content-right {
		align-items: center;
		justify-content: flex-end;
}

	.content-wrapper {
		display: flex;
		height: 100%;
		flex-direction: column;
		justify-content: center;
		gap: 0.5rem;
}

	.small-card-content-left .content-wrapper {
		align-items: flex-start;
		text-align: left;
}

	.small-card-content-right .content-wrapper {
		align-items: flex-end;
		text-align: right;
}

	.cta {
		display: flex;
		height: 16px;
}

	.cta-left {
		justify-content: flex-start;
}

	.cta-right {
		justify-content: flex-end;
}

	.badge {
		margin-top: 1px;
		display: flex;
		height: 16px;
		align-items: center;
		justify-content: center;
		border-radius: 4px;
		background-color: var(--color-background-500);
		font-size: 9px;
		font-weight: 600;
		color: var(--color-background-900);
		padding: 0 8px;
		width: -moz-fit-content;
		width: fit-content;
}

	.badge-text {
		height: 9px;
		line-height: 9px;
}

	@media (min-width: 1024px) {
		.small-card {
			width: calc(50% - 0.25rem);
			height: calc(50% - 0.25rem);
			aspect-ratio: auto;
		}

		.badge {
				margin-top: 4px;
				font-size: 11px;
			padding: 0 6px;
		}

		.content-wrapper {
				gap: 0.375rem;
		}

		.small-card-bg {
				top: 0px;
				left: 0px;
				right: 0px;
				bottom: 0px;
		}
	}
</style>
